import moduleRootSagas from "./sagas/modules";

// IMPORTANT : ne pas ajouter directement de watchers ici.
// Ajouter les watchers dans src/app/redux/sagas/modules/<module>RootSaga.js
// Cela évite les conflits Git entre équipes.
export default function* rootSaga() {
  yield* moduleRootSagas();
}
